<template>
  <div class="general-property">
    <a-form
      ref="propertyForm"
      :model="formState"
      layout="vertical"
      :rules="rules"
      class="property-form"
    >
      <a-form-item name="identifier">
        <template #label>
          属性编码
          <a-popover>
            <template #content>
              <p>1.支持数字、小写字母和_;</p>
              <p>2.不能以数字开头。</p>
            </template>
            <svg-icon iconClass="question-circle" />
          </a-popover>
        </template>
        <a-input
          v-model:value="formState.identifier"
          :disabled="isUpdate === 1"
          placeholder="请输入属性编码"
          :maxlength="130"
        ></a-input>
      </a-form-item>
      <a-form-item label="属性名称" name="name">
        <a-input
          v-model:value="formState.name"
          placeholder="请输入属性名称"
          :maxlength="130"
        ></a-input>
      </a-form-item>
      <a-form-item label="读写类型"> 只读 </a-form-item>
      <a-form-item label="类别"> 自定义 </a-form-item>
      <a-form-item label="描述" name="description">
        <a-textarea
          v-model:value="formState.description"
          placeholder="请输入描述"
          :maxlength="500"
        ></a-textarea>
      </a-form-item>
      <div class="data-type-title required">数据类型</div>
      <data-type-define ref="dataTDefine" :dataTypeValue="originValue"></data-type-define>
    </a-form>
  </div>
</template>
<script>
import { recursive, handleValidate as validateForms } from "../components/validateForm";
import DataTypeDefine from "../components/data-type/data-type-define.vue";
import { defineComponent, ref, reactive, provide, inject } from "vue";
import { message, Popover, Radio } from "ant-design-vue";
import {
  addNewProperty,
  updateProperty,
  memberIdentifierCheck,
  memberNameCheck
} from "@/api/console/model/model-definition";
export default defineComponent({
  props: {
    visible: {
      type: Boolean
    },
    prop: {
      type: Object
    }
  },
  emits: ["update:visible"],
  setup(props, ctx) {
    const instanceId = inject("instanceId");
    let formState;
    let isUpdate = props.prop.value.update;
    let originValue = reactive({
      dataType: "decimal",
      specifications: [],
      specification: {},
      multiple: false
    });

    const dataTDefine = ref(null);
    let checkIdentifier = async (_rule, value) => {
      // 编辑时不需要校验
      if (isUpdate === 1) {
        return Promise.resolve();
      }
      if (value === "") {
        return Promise.reject("必填未填");
      }
      if (/^(_|[a-z])[_a-z0-9]*$/.test(value)) {
        if (value.length >= 64) {
          return Promise.reject("长度须大于0且小于64");
        }
      } else {
        return Promise.reject("编码必须由半角小写字母,数字,_组成,首字母必须是小写字母或_");
      }
      const data = {
        ...JSON.parse(JSON.stringify(formState)),
        ...JSON.parse(JSON.stringify(originValue))
      };
      let numObj = { num: 0 };
      recursive(data, "identifier", value, numObj);
      if (numObj.num > 1) {
        return Promise.reject("编码重复");
      } else {
        const res = await memberIdentifierCheck({ validityValue: value });
        if (!res.success) {
          return Promise.reject("该编码已存在");
        }
        return Promise.resolve();
      }
      // return Promise.resolve();
    };
    let checkName = async (_rule, value) => {
      if (value === "") {
        return Promise.reject("必填未填");
      }
      if (value.length >= 64) {
        return Promise.reject("长度须大于0且小于64");
      }
      const data = {
        ...JSON.parse(JSON.stringify(formState)),
        ...JSON.parse(JSON.stringify(originValue))
      };
      let numObj = { num: 0 };
      recursive(data, "name", value, numObj);
      if (numObj.num > 1) {
        return Promise.reject("名称重复");
      } else {
        if (isUpdate === 1) {
          const res = await memberNameCheck({ validityValue: value, id: props.prop.value.id });
          if (!res.success) {
            return Promise.reject("该名称已存在");
          }
        } else {
          const res = await memberNameCheck({ validityValue: value });
          if (!res.success) {
            return Promise.reject("该名称已存在");
          }
        }
        return Promise.resolve();
      }
    };
    const rules = {
      identifier: [
        {
          required: true,
          trigger: "blur",
          validator: checkIdentifier
        }
      ],
      name: [
        {
          required: true,
          trigger: "blur",
          validator: checkName
        }
      ],
      description: [
        {
          required: true,
          message: "请输入描述",
          trigger: "blur"
        }
      ]
    };

    const onSubmit = () => {
      let params = { ...formState, ...originValue, accessMode: "r", instanceId: instanceId.value };
      // 编辑
      if (props.prop.value.update === 1) {
        // TODO
        propertyForm.value.validate().then(() => {
          // let params = { ...formState, ...originValue };
          validateForms(originValue)
            .then(() => {
              updateProperty(params).then((res) => {
                if (res.success) {
                  // message.success("保存成功");
                  ctx.emit("update:visible", false);
                }
              });
            })
            .catch(() => {});
        });
      } else {
        // 新增和复制
        propertyForm.value.validate().then(() => {
          // let params = { ...formState, ...originValue };
          if (params.id) delete params.id;
          validateForms(originValue)
            .then(() => {
              addNewProperty(params).then((res) => {
                if (res.success) {
                  if (props.prop.value.update === 2) message.success("复制成功");
                  else message.success("新增成功");
                  ctx.emit("update:visible", false);
                }
              });
            })
            .catch(() => {});
        });
      }
    };

    const closeDrawer = () => {
      ctx.emit("update:visible", false);
    };

    const propertyForm = ref();

    // 判断新增还是编辑
    if (isUpdate) {
      // 在编辑时，需要将tabel中的列数据转换，以适应于将数据填到编辑栏中。
      formState = reactive({
        identifier: reactive(props.prop).value.identifier,
        name: reactive(props.prop).value.name,
        accessMode: reactive(props.prop).value.accessMode,
        // required: reactive(props.prop).value.required,
        description: reactive(props.prop).value.description,
        id: reactive(props.prop).value.id
      });

      originValue = reactive({
        // prop: props.prop.value,
        dataType: props.prop.value.dataType,
        specifications: props.prop.value.specifications,
        specification: props.prop.value.specification,
        multiple: props.prop.value.multiple,
        released: isUpdate === 2 ? false : props.prop.value.islink // 复制时不限制修改
      });
    } else {
      // 所有数据类型 新增
      formState = reactive({
        identifier: "",
        name: "",
        accessMode: "rw",
        // required: true,
        description: ""
      });
    }

    // provide
    provide("provideData", { formState, originValue });

    return {
      propertyForm,
      formState,
      rules,
      onSubmit,
      closeDrawer,
      isUpdate,
      originValue,
      dataTDefine
    };
  },
  components: {
    DataTypeDefine,
    [Popover.name]: Popover,
    [Radio.name]: Radio,
    [Radio.Group.name]: Radio.Group
  }
});
</script>
<style lang="less" scoped>
.general-property {
  .data-type-title {
    margin-bottom: 8px;
    padding-top: 16px;
    color: #1d2129;
    line-height: 22px;
    border-top: 1px solid #f2f3f5;
  }
}
.ant-form-item-label {
  .svg-icon {
    margin-left: 5px;
  }
}
</style>
